export default String.raw`
const Deliveries = (() => {
    'use strict';
    const toStatus = (statusId) => {
        switch (statusId) {
            case 1:
                return { Color: '#2DCCFF', Name: __translations.ProductOrdered }
            case 2:
                return { Color: '#F5A623', Name: __translations.DeliveryNotAccepted }
            case 3:
                return { Color: '#008945', Name: __translations.DeliveryAccepted }
            default:
                return { Color: '#A4ABB6', Name: __translations.Unknown }
        }
    };

    const getDeliveries = async (productId) => {
        const data = {
            __action: 'sync/exec',
            __csrf: __CSRF,
            worker: 'erpData',
            message: JSON.stringify({
                command: 'CDN.eShop_GetPurchaseOrders',
                parameters: {
                    LanguageId: __lngId,
                    ProductId: productId
                }
            })
        };

        try {
            const response = await $.post('', data);

            if (response?.action?.Code == 101 || response?.action?.Code == 108) {
                return [];
            }

            if(response?.action?.Code != 0) {
                app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
                return;
            }

            const deliveries = response?.action?.Object[0]?.Result;
    
            if (!deliveries || deliveries.length === 0) {
                return [];
            }

            return deliveries.map(delivery => ({
                ...delivery,
                Status: toStatus(delivery.Status),
                ExpectedDate: new Date(delivery.ExpectedDate).toLocaleDateString()
            }));
        } catch(error) {
            console.error("Error fetching deliveries:", error);
        }
    };

    return {
        getDeliveries
    };
})();

const DeliveriesUI = (() => {
    'use strict';
    const button = document.querySelector('.check-deliveries-js');

    if (!button) {
        return;
    }

    $('body').on('click', '.check-deliveries-js', function(e) {
        if (typeof withSpinner !== 'function') {
            return;
        }    
        
        withSpinner(async (event) => {
            const productId = $(event.currentTarget).data('product-id');

            if (!productId) {
                return;
            }

            const popup = document.querySelector('.check-deliveries-popup-js');
            
            if (!popup) {
                return;
            }

            const deliveries = await Deliveries.getDeliveries(productId);

            if (!deliveries) {
                return;
            }

            if (deliveries.length === 0) {
                popup.showModal();
                return;
            }

            let tableRows = '';
            deliveries.forEach((delivery) => {
                tableRows += '<tr class="table__row"><td class="table__cell">' + 
                    delivery.Quantity + '</td><td class="table__cell"><div class="state ent"><svg height="8" width="8" fill="' + 
                    delivery.Status.Color + '"><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#circle-solid"></use></svg><span>' + 
                    delivery.Status.Name + '</span></div></td><td class="table__cell date">' +  
                    delivery.ExpectedDate +'</td></tr>';
            });

            $('.check-deliveries-table-content-js').html(tableRows);
            popup.showModal();
        })(e);
    });
})();
`